export interface IAppReportEditUnitChange {
    canEdit: boolean;
    canEditWithoutLimit: boolean;
    canRemove: boolean;
}

export class AppReportEditUnitChange implements IAppReportEditUnitChange {
    canEdit: boolean;
    canEditWithoutLimit: boolean;
    canRemove: boolean;
    
    constructor();
    constructor(obj: IAppReportEditUnitChange);
    constructor(obj?: any) {
        this.canEdit = obj && obj.canEdit || false;
        this.canEditWithoutLimit = obj && obj.canEditWithoutLimit || false;
        this.canRemove = obj && obj.canRemove || false;
    }
}